import { render, staticRenderFns } from "./SendComments.vue?vue&type=template&id=bfb55a3a&scoped=true&"
import script from "./SendComments.vue?vue&type=script&lang=js&"
export * from "./SendComments.vue?vue&type=script&lang=js&"
import style0 from "./SendComments.vue?vue&type=style&index=0&id=bfb55a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb55a3a",
  null
  
)

export default component.exports